module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.isLoading && _vm.showSpinner) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.requiredActions && _vm.amountTotal > 0) ? _c('div', {
    staticClass: "requiredActions"
  }, [_c('div', {
    staticClass: "is-row header"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.amountTotal))]), _vm._v("Actions required\n            ")])]), _vm._v(" "), (_vm.amountToPublish > 0) ? _c('div', {
    staticClass: "is-row"
  }, [_c('RequiredActionsItem', {
    attrs: {
      "forecasts": _vm.requiredActions.toPublish.forecasts,
      "forecast-windows": _vm.requiredActions.toPublish.forecastWindows,
      "amount": _vm.amountToPublish,
      "title": 'Forecasts to publish',
      "action-color": '#62a0cf'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.amountToValidate > 0) ? _c('div', {
    staticClass: "is-row"
  }, [_c('RequiredActionsItem', {
    attrs: {
      "forecasts": _vm.requiredActions.toValidate.forecasts,
      "forecast-windows": _vm.requiredActions.toValidate.forecastWindows,
      "amount": _vm.amountToValidate,
      "title": 'Forecasts to validate',
      "action-color": '#544e58'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.amountToSubmit > 0) ? _c('div', {
    staticClass: "is-row"
  }, [_c('RequiredActionsItem', {
    attrs: {
      "forecast-windows": _vm.requiredActions.toSubmit.forecastWindows,
      "amount": _vm.amountToSubmit,
      "title": 'Forecasts to submit',
      "action-color": '#116184'
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310580eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/widgets/RequiredActionsWidget.vue
// module id = 3109
// module chunks = 0